import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('pulling_from_oracle_netsuite'),
    description: defineMessage('pluraltemplatename_in_t_ed_from_oracle_netsuite'),
    externalSubmitterDescription: defineMessage('pluraltemplatename_will_rejections_and_comments'),
    externalSubmitterDescriptionEmpty: defineMessage('enter_the_user_who_will_anycom_can_also_be_used'),
    learnMore: defineMessage('learn_more'),
    externalSubmitterRequiredValidationText: defineMessage('please_select_a_requester'),
    chooseRequester: defineMessage('choose_a_requester'),
};
